import React, { useEffect } from "react";
import { PageLayout, InitialOfferSkeletonLoader } from "../../components";
import { InitialOfferHelmet } from "../../components/SellHelmets";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useInitialOffer } from "./useInitialOffer";
import InitialValuation from "../InitialValuation/InitialValuation";
import { ValuationAccuracy } from "../../helpers/valuationAccuracy";
import { getPrePopulatedOrUpdatedAnswers } from "../helpers";

export default function InitialOfferContainer() {
  const {
    appraisalLoading,
    valuationLoading,
    isLoading,
    stepNumber,
    dispatch,
    appraisalAndValuationRequest,
    handleSubmit,
    showSpinner,
    valuation,
    valuationRequest,
    answersChanged,
    answersComplete,
    isPartExchangeCustomer,
    getStepNumber,
    questions,
    questionsAndAnswers,
    quickValuation,
    subheaderTitle
  } = useInitialOffer();

  const stepNumberProp = getStepNumber(isPartExchangeCustomer, 14, stepNumber);

  const landingRequests = () => {
    dispatch(appraisalSlice.actions.setIsFullValuation(false));
    if (!valuation) {
      dispatch(appraisalSlice.actions.setIsLoading(true));
      appraisalAndValuationRequest(ValuationAccuracy.QUICK_VALUATION);
    } else {
      if (answersChanged && answersComplete) {
        dispatch(appraisalSlice.actions.setIsLoading(true));
        dispatch(appraisalSlice.actions.setAnswersChanged(false));
        valuationRequest(ValuationAccuracy.QUICK_VALUATION);
      }
    }
    if (valuation && quickValuation && !answersComplete) {
      const defaultOrUpdatedAnswers = getPrePopulatedOrUpdatedAnswers(
        questions,
        questionsAndAnswers
      );
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers(defaultOrUpdatedAnswers)
      );
    }
  };
  useEffect(landingRequests, []);
  if (isLoading || valuationLoading || appraisalLoading) {
    return (
      <>
        <InitialOfferHelmet />
        <PageLayout>
          <PageLayout.Header title={subheaderTitle} step={stepNumberProp} />
          <PageLayout.Content>
            <InitialOfferSkeletonLoader />
          </PageLayout.Content>
        </PageLayout>
      </>
    );
  }
  return (
    <>
      {!isLoading && (
        <>
          <InitialValuation onSubmit={handleSubmit} showSpinner={showSpinner} />
        </>
      )}
    </>
  );
}
